import { render, staticRenderFns } from "./FaqSettings.vue?vue&type=template&id=07180003&scoped=true"
import script from "./FaqSettings.vue?vue&type=script&lang=js"
export * from "./FaqSettings.vue?vue&type=script&lang=js"
import style0 from "./FaqSettings.vue?vue&type=style&index=0&id=07180003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07180003",
  null
  
)

export default component.exports